import { useEffect, useState } from "react";

/**
 * useCancelableRequest - a custom hook for data fetching with AbortController and loading/error state.
 * @param {Function} apiFn - The API function to call. Must accept (...args, { signal })
 * @param {Array} args - Arguments to pass to the API function (excluding options)
 * @param {Array} deps - Dependency array for useEffect
 * @returns {Object} { data, loading, error }
 */
function useCancelableRequest(apiFn, args, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setData(null);
    setError(null);
    const controller = new AbortController();

    apiFn(...args, { signal: controller.signal })
      .then(setData)
      .catch((err) => {
        if (err.name !== "CanceledError" && err.name !== "AbortError") {
          setError(err);
        }
      })
      .finally(() => setLoading(false));

    return () => controller.abort();
    // eslint-disable-next-line
  }, deps);

  return { data, loading, error };
}

export default useCancelableRequest;
